import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const getParlamentDecisions = async (pageNum, pageSize, searchTerm = "", startDate = null, endDate = null) => {
  try {
    const response = await axios.post(`${API_URL}/ParlamentDecisions/GetParlamentDecisionses`, {
      pageNum,
      pageSize,
      searchTerm,
      sortBy: "",
      startDate: startDate ? startDate.toISOString() : "2024-03-20T22:10:19.398Z",
      endDate: endDate ? endDate.toISOString() : "2026-03-20T22:10:19.398Z"
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching parlament decisions:', error);
    throw error;
  }
};

export const getParlamentMembers = async (pageNum = 1, pageSize = 50, searchTerm = "", startDate = null, endDate = null) => {
  try {
    const response = await axios.post(`${API_URL}/ParlamentMembers/GetParlamentMembers`, {
      pageNum,
      pageSize,
      searchTerm,
      sortBy: "",
      startDate: startDate ? startDate.toISOString() : "2007-03-25T11:47:12.648Z",
      endDate: endDate ? endDate.toISOString() : "2030-04-13T00:37:05.648Z"
    });

    return response.data;
  } catch (error) {
    console.error('Error fetching parlament members:', error);
    throw error;
  }
};

export const getParlamentDecisionById = async (guid) => {
  try {
    console.log('API URL:', `${API_URL}/ParlamentDecisions/GetParlamentDecisionsById`);
    console.log('Request payload:', { guid });
    
    const response = await axios.post(`${API_URL}/ParlamentDecisions/GetParlamentDecisionsById`, {
      guid: guid
    });
    
    console.log('Raw API response:', response);
    return response.data;
  } catch (error) {
    console.error('Error fetching parlament decision detail:', error);
    console.error('Error response data:', error.response?.data);
    console.error('Error status:', error.response?.status);
    throw error;
  }
};
